const version = process.env.REACT_APP_BUILD_VERSION || "1.15.1";

export const buildInfo = {
  version,
  label: `v${version}`,
};
